module.exports = __webpack_public_path__ + "img/[傲慢].25253f40.svg";